import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  toggleOpen: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  toggleOpen
}: FAQItemProps) {
  return <div className="border-b border-zinc-800 last:border-b-0" data-id="element-55">
      <button className="flex justify-between items-center w-full py-5 text-left" onClick={toggleOpen} data-id="element-56">
        <h3 className="text-lg font-semibold" data-id="element-57">{question}</h3>
        {isOpen ? <ChevronUpIcon size={20} className="text-red-600" data-id="element-58" /> : <ChevronDownIcon size={20} className="text-red-600" data-id="element-59" />}
      </button>
      {isOpen && <div className="pb-5 text-gray-400" data-id="element-60">
          <p data-id="element-61">{answer}</p>
        </div>}
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'What experience level is required to join IKHANFX?',
    answer: "IKHANFX welcomes traders of all experience levels. Our courses range from beginner fundamentals to advanced strategies. We've designed our platform to support your trading journey regardless of where you're starting from."
  }, {
    question: 'How do the membership plans work?',
    answer: 'Our membership plans provide different levels of access to our trading courses and resources. The Basic plan gives access to foundational courses, while Premium and Elite plans include advanced strategies, one-on-one coaching, and live trading sessions. All plans are billed monthly or annually with a discount for annual commitments.'
  }, {
    question: 'Can I cancel my subscription at any time?',
    answer: "Yes, you can cancel your subscription at any time. If you cancel, you'll continue to have access until the end of your current billing period. We don't offer refunds for partial months, but you won't be charged for the following period."
  }, {
    question: 'Do you offer one-on-one coaching?',
    answer: "Yes, one-on-one coaching is available with our Premium and Elite membership plans. You'll get personalized guidance from our expert traders who will help you develop strategies tailored to your trading goals and risk tolerance."
  }, {
    question: 'How often is new content added?',
    answer: 'We add new content weekly, including market analysis, strategy updates, and new course modules. Our team constantly monitors market conditions to ensure our educational materials reflect current trading environments.'
  }, {
    question: 'Is there a community of traders I can interact with?',
    answer: "Absolutely! All membership plans include access to our private community where you can interact with fellow traders and our instructors. It's a great place to share ideas, ask questions, and get feedback on your trading strategies."
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 bg-zinc-950" data-id="element-62">
      <div className="container mx-auto px-4" data-id="element-63">
        <div className="text-center mb-12" data-id="element-64">
          <h2 className="text-4xl font-bold mb-4" data-id="element-65">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-66">
            Find answers to common questions about our trading education
            platform and membership options.
          </p>
        </div>
        <div className="max-w-3xl mx-auto bg-zinc-900 rounded-xl p-6 md:p-8" data-id="element-67">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} toggleOpen={() => toggleFAQ(index)} data-id="element-68" />)}
        </div>
      </div>
    </section>;
}